import React from 'react'
import { Card, CardBody, Col, Row } from "reactstrap";


// component
import WlCardHeader from "../components/WlCardHeader";
import WlCardComment from "../components/WlCardComment";
import WishlistButtons from "../tools/WishlistButtons";

// label
import {
    LB_ALLERGIC, LB_ALLERGIES,
    LB_DATE, LB_GLUTEN_FREE, LB_HOUR, LB_REST_ALIM, LB_VEGAN, LB_VEGETARIAN,
} from "../../i18n/i18n";

// utils
import { getWishlistOption, wishlistTypes } from "../../../util/WishlistUtils";

const RestaurantViewComponent = props => {
    const option = getWishlistOption( wishlistTypes?.restaurant )

    const getPaxDetailValue = code => {
        let pax = props?.component?.paxDetails?.find( c => c?.typeRestriction?.code === code )
        return pax?.value || 0
    }

    return <Card className={'wl-card'}>
        <CardBody className={'wl-card-content'}>
            <WlCardHeader
                icon={ option?.icon }
                title={ option?.title }
                subTitle={props?.component?.title}
                pax={props?.component?.pax}
            />

            <div className={'wl-card-body ptb-1em mb-1em'}>
                <Row>
                    <Col>
                        <div>
                            <label className={'wl-label-title w-65px'}>{LB_DATE}</label> &nbsp;
                            <label className={'wl-label-value'}> {props?.component?.date}</label>
                        </div>
                        <div>
                            <label className={'wl-label-title w-65px'}>{LB_VEGETARIAN}</label> &nbsp;
                            <label className={'wl-label-value'}> { getPaxDetailValue('rest_vegetarian') }</label>
                        </div>
                        <div>
                            <label className={'wl-label-title w-65px'}>{LB_GLUTEN_FREE}</label> &nbsp;
                            <label className={'wl-label-value'}> { getPaxDetailValue('rest_gluten_free') }</label>
                        </div>
                        <div>
                            <label className={'wl-label-title w-65px'}>{LB_ALLERGIC}</label> &nbsp;
                            <label className={'wl-label-value'}> { getPaxDetailValue('rest_allergic') }</label>
                        </div>
                    </Col>
                    <Col>
                        <div>
                            <label className={'wl-label-title w-65px'}>{LB_HOUR}</label> &nbsp;
                            <label className={'wl-label-value'}>{props?.component?.hour}</label>
                        </div>
                        <div>
                            <label className={'wl-label-title w-65px'}>{LB_VEGAN}</label> &nbsp;
                            <label className={'wl-label-value'}>{ getPaxDetailValue('rest_vegan') }</label>
                        </div>
                        <div>
                            <label className={'wl-label-title w-65px'}>{LB_REST_ALIM}</label> &nbsp;
                            <label className={'wl-label-value'}>{ getPaxDetailValue('rest_rest_alim') }</label>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className={'w-px'}>
                            <span className={'wl-label-title w-55px'}>{LB_ALLERGIES}</span> &nbsp;
                            <span className={'wl-label-value'}>{props?.component?.allergies}</span>
                        </div>
                    </Col>
                </Row>
            </div>

            <WlCardComment comment={props?.component?.comments}/>

            <WishlistButtons from={'wishlist'} {...props} />
        </CardBody>
    </Card>
}

export default RestaurantViewComponent